export default "__VITE_ASSET__b0173585__"